import SearchSelect from "@ui-components/SearchSelect";
import {useState} from "react";
import {COMPONENT_STYLE_OVERRIDE} from "@components/UserTableFilter";
import {Column} from "@material-table/core";
import {Option} from "./types";

interface UsersKpiTableFilterProps<T extends object> {
  type?: string;
  columnDef: Column<T>;
  onFilterChanged: (columnId: string, value: any) => void;
  userOptions: Option[];
}

export const UsersKpiTableFilter = ({
  columnDef,
  onFilterChanged,
  userOptions,
}: UsersKpiTableFilterProps<any>) => {

  const [selected, setSelected] = useState<Option | Option[] | null>(null);

  return (
    <div>
      <SearchSelect
        options={userOptions}
        value={selected}
        onChange={(selected:Option[] | null) => {
          onFilterChanged(
            (columnDef as any).tableData.id as string,
            selected?.map(s => s.value)
          );
          setSelected(selected);
        }}
        mainStyle="border-2 border-kerakoll-400 mt-1 mb-0"
        componentStyle={COMPONENT_STYLE_OVERRIDE as any}
        isMulti={true}
      />
    </div>
  )

}